/*
 * @Author: edvardchen
 * @Date:   2016-11-29 14:17:31
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:24:25
 */

import PropTypes from 'prop-types';

const contextTypes = {
  openQb: PropTypes.func,
  download: PropTypes.func,
  downloadOrOpenQb: PropTypes.func,
  onShare: PropTypes.func,
  setDownloadBar: PropTypes.func,
  addSharePower: PropTypes.func,
  checkAndroidQB: PropTypes.func,
};
export default contextTypes;
